/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="55.38"
        height="95.58"
        viewBox="0 0 55.38 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M49.01 0H6.42A6.41 6.41 0 0 0 .01 6.42v82.74a6.41 6.41 0 0 0 6.42 6.42h42.58a6.41 6.41 0 0 0 6.42-6.42V6.42A6.42 6.42 0 0 0 49.01 0ZM6.42 2.5h42.59a3.92 3.92 0 0 1 3.92 3.92v82.74a3.91 3.91 0 0 1-3.92 3.92H6.42a3.91 3.91 0 0 1-3.92-3.92V6.42A3.92 3.92 0 0 1 6.42 2.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M54.12 12.92a1.25 1.25 0 0 1 .13 2.49h-53a1.252 1.252 0 0 1-.13-2.5h53ZM54.12 77.56a1.25 1.25 0 0 1 .13 2.49h-53a1.252 1.252 0 0 1-.13-2.5h53ZM33.81 6.71a1.002 1.002 0 0 1 .12 2H21.57a1.002 1.002 0 0 1-.12-2h12.36Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M27.69 53.12a9.71 9.71 0 0 1 6.57 2.6 1.253 1.253 0 0 1-1.69 1.85 7.08 7.08 0 0 0-9.76 0 1.253 1.253 0 1 1-1.69-1.85 9.74 9.74 0 0 1 6.57-2.6ZM27.69 44.1a18.24 18.24 0 0 1 12.77 5.25 1.25 1.25 0 1 1-1.74 1.79 15.67 15.67 0 0 0-22.06 0 1.25 1.25 0 1 1-1.74-1.79 18.24 18.24 0 0 1 12.77-5.25Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M27.69 35.08A26.77 26.77 0 0 1 46.63 43a1.25 1.25 0 1 1-1.76 1.77 24.17 24.17 0 0 0-34.36 0A1.25 1.25 0 1 1 8.75 43a26.77 26.77 0 0 1 18.94-7.92Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M27.69 90.14a3.58 3.58 0 1 1 3.58-3.58 3.58 3.58 0 0 1-3.58 3.58"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'MobileDeviceWithWifiSymbolIcon';

export default Icon;
